import { DMModal, DMModalContent, DMModalTitle } from "../../../shared/DMModal";
import { DataTable } from "../DataTable/DataTable";
import { DataTableContextProvider } from "../DataTable/DataTableContext";

export const CourseStatsModal: React.FC<{
  open: boolean;
  onClose: () => void;
}> = ({ open, onClose }) => (
  <DMModal
    visible={open}
    onClose={onClose}
    style={{
      width: "75vw",
      maxWidth: "75vw",
    }}
  >
    <DMModalTitle>Course Statistics</DMModalTitle>
    <DMModalContent className="rounded-lg bg-dm-charcoal-100 p-6">
      <DataTableContextProvider
        source="/manager_new/parent-portal/learner-course-stats-beta"
        defaults={{
          sortBy: [{ id: "name" }],
        }}
        fetchOnLoad
        downloadButton={false}
      >
        <DataTable />
      </DataTableContextProvider>
    </DMModalContent>
  </DMModal>
);
